import { createContext } from 'react';
import { ApiInstanceDto } from '.';

export interface ApiInstanceContextProps {
    settings: ApiInstanceDto | null;
}

export const ApiInstanceContext = createContext<ApiInstanceContextProps | null>(null);
